import React from 'react';
import '../timeline.css';

const Clause = ({ parts }) => (
  <>{parts.map((p, i) => (p.bold ? <b key={i}>{p.text}</b> : <React.Fragment key={i}>{p.text}</React.Fragment>))}</>
);

// Uppercase the first letter of a clause (its first part). Applied to standalone clauses —
// bulleted list items and card chips — NOT to the single inline clause, which flows
// mid-sentence after "A customer who/whose" and must stay lowercase.
export const capFirst = (parts) => (parts.length
  ? [{ ...parts[0], text: parts[0].text.charAt(0).toUpperCase() + parts[0].text.slice(1) }, ...parts.slice(1)]
  : parts);

export default function SegmentSummary({ model, className = '' }) {
  const cls = `seg-summary ${className}`.trim();
  if (!model || model.clauseCount === 0) {
    return <div className={cls}>Reaches everyone</div>;
  }
  if (model.groups.length === 1) {
    const group = model.groups[0];
    if (group.clauses.length === 1) {
      const clause = group.clauses[0];
      const who = clause.kind === 'verb' ? 'who' : 'whose';
      return <div className={cls}>A customer {who} <Clause parts={clause.parts} />.</div>;
    }
    return (
      <div className={cls}>
        <div className="lead">A customer who matches {group.op} of:</div>
        <ul className="seg-bl">{group.clauses.map((clause, i) => <li key={i}><Clause parts={capFirst(clause.parts)} /></li>)}</ul>
      </div>
    );
  }
  const divider = model.outer === 'any' ? 'or' : 'and';
  return (
    <div className={cls}>
      <div className="lead">A customer who matches {model.outer} of these groups:</div>
      {model.groups.map((group, i) => (
        <React.Fragment key={i}>
          {i > 0 && <div className="seg-gsep">— {divider} —</div>}
          <div className="seg-gblk">
            <div className="seg-gtag">{group.op} of:</div>
            <ul className="seg-bl">{group.clauses.map((clause, j) => <li key={j}><Clause parts={capFirst(clause.parts)} /></li>)}</ul>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}
